/* eslint-disable */
import React, { useContext, useState, useEffect } from 'react';
import {
  CustomerRecordStateContext,
  CustomerRecordDispatchStateContext,
} from '../../context/CustomerRecordCheck/CustomerRecordProvider';
import {
  Grid,
  Typography,
  RACTable,
  RACCheckBox,
  RACButton,
  Card,
  CardContent,
  RACTableCell,
  RACTableRow,
  CircularProgress,
  RACDateTimeLabel,
} from '@rentacenter/racstrap';
import { globalStyles } from '../../jsStyles/globalStyles';
import {
  columnKeyMap,
  CRCGridHeader,
  INITIAL_OFFSET,
  PAST_DUE_LIST_API_LIMIT,
  NO_RECORDS_FOUND_RECORD_CHECK_MESSAGE,
  RECORD_CHECK_REQUEST_ERROR_MESSAGE,
  RECORD_CHECK_REQUEST_ERROR_MESSAGE_2,
  RECORD_CHECK_SUCCESS_MESSAGE,
  RECORD_CHECK_SUCCESS_MESSAGE_2,
  RECORD_HEIGHT,
} from '../../constants/constants';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Loader } from '../../common/ApiStateWrapper/ApiStateWrapper';
import { abbrev, formatDateString, maskData } from '../../utils/utils';
import { RequestCustomerRecordChk } from '../../api/Customer';
import { ApiSuccessModal } from '../../common/ApiSuccess/ApiSuccess';
import { ReactComponent as SortDownIcon } from '../../assets/img/sort-down-icon.svg';
import { ReactComponent as SortUpIcon } from '../../assets/img/sort-up-icon.svg';
import {
  getCustomerInformation,
  sortData,
} from '../../utils/getCustomerInformation';
import { useStoreDetails } from '../../context/Store/StoreProvider';

const CustomerQueue = () => {
  const classes = globalStyles();
  const { queuedCustomers } = useContext(CustomerRecordStateContext);

  const { DateTimeLocalization, store } = useStoreDetails();
  const { addToQueue, selectedCustomer } = useContext(
    CustomerRecordDispatchStateContext
  );
  const [isNoRecordsFound, setIsNoRecordsFound] = useState<boolean>(false);
  const [offset, setOffset] = useState<number>(INITIAL_OFFSET);
  const [selectedCount, setSelectedCount] = useState<number>(INITIAL_OFFSET);
  const [selectAll, setSelectAll] = useState(false);
  const [containerHeight, setContainerHeight] = useState(225);
  const [screenLoader, setScreenLoader] = useState<boolean>(false);
  const [isApiSuccessOpen, setIsApiSuccessOpen] = useState(false);
  const [apiMessage, setApiMessage] = useState('');
  const [apiSubMessage, setApiSubMessage] = useState('');
  const [isApiError, setIsApiError] = useState<boolean>(false);
  const [sortedColumn, setSortedColumn] = useState<string | null>(null);
  const [sortOrder, setSortOrder] = useState<'asc' | 'desc'>('asc');
  const [remainingCust, setRemainingCust] = useState<any>(null);

  useEffect(() => {
    const selected = queuedCustomers.filter((c) => c.checked === 1).length;
    setSelectedCount(selected);

    const allSelected =
      queuedCustomers.length > 0 &&
      queuedCustomers.every((c) => c.checked === 1);
    setSelectAll(allSelected);

    const visibleCount = queuedCustomers.length;

    setContainerHeight(
      visibleCount === 0 || visibleCount < 4 ? RECORD_HEIGHT * 3 : 300
    );
  }, [queuedCustomers]);

  const fetchNextPage = () => {
    if (!queuedCustomers || queuedCustomers.length < 1) return;
    setOffset(offset + PAST_DUE_LIST_API_LIMIT);
  };

  const handleCheckboxChange = (e: any, index: number) => {
    const selected = e.target.checked;
    const updatedResults = [...queuedCustomers];
    updatedResults[index] = {
      ...updatedResults[index],
      checked: selected ? 1 : 0,
    };
    addToQueue(updatedResults, false);
  };

  const handleSelectAll = (e: any) => {
    const newSelectAll = e.target.checked;
    setSelectAll(newSelectAll);

    const updatedResults = queuedCustomers.map((customer) => ({
      ...customer,
      checked: newSelectAll ? 1 : 0,
    }));

    addToQueue(updatedResults, false);
  };

  const handleSort = (column: string) => {
    const key = columnKeyMap[column];
    const order =
      sortedColumn === column && sortOrder === 'asc' ? 'desc' : 'asc';
    const sorted = sortData(queuedCustomers, key, order);
    addToQueue(sorted, false);
    setSortedColumn(column);
    setSortOrder(order);
  };

  const handleRecordChkReqst = async () => {
    try {
      setScreenLoader(true);

      const selected = queuedCustomers.filter(
        (customer) => customer.checked === 1
      );
      const remaining = queuedCustomers.filter(
        (customer) => customer.checked !== 1
      );

      const enrichedCustomers = await Promise.all(
        selected.map(async (customer) => {
          const decryptedInfo = await getCustomerInformation(customer);
          return {
            customerId: customer.customerId,
            firstName: decryptedInfo.firstName,
            lastName: decryptedInfo.lastName,
            ssn: decryptedInfo.ssn,
            dateOfBirth: decryptedInfo.dateOfBirth,
            requiredSkipTraceData: {
              phone: 'Y',
              address: 'Y',
              email: 'Y',
              employer: 'Y',
              reference: 'Y',
            },
          };
        })
      );

      const payload = {
        customerDetails: enrichedCustomers,
      };

      const response = await RequestCustomerRecordChk(payload);
      console.log('response', response);

      const rawData = response?.customreResponse?.[0];

      if (rawData?.error && rawData?.error?.toUpperCase()?.includes('REPORTTOKEN')) {
        setScreenLoader(false);
        setApiMessage(NO_RECORDS_FOUND_RECORD_CHECK_MESSAGE);
        setApiSubMessage('');
        setIsApiSuccessOpen(true);
        setIsNoRecordsFound(true);
      } else if (rawData?.error) {
        setScreenLoader(false);
        setApiMessage(RECORD_CHECK_REQUEST_ERROR_MESSAGE);
        setApiSubMessage(RECORD_CHECK_REQUEST_ERROR_MESSAGE_2);
        setIsApiSuccessOpen(true);
        setIsApiError(true);
      } else if (rawData?.transactionId) {
        setScreenLoader(false);
        setIsApiError(false);
        setApiMessage(RECORD_CHECK_SUCCESS_MESSAGE);
        setApiSubMessage(RECORD_CHECK_SUCCESS_MESSAGE_2);
        setIsApiSuccessOpen(true);
        selectedCustomer(selected);
        setRemainingCust(remaining);
      }
    } catch (error) {
      console.error('Request failed:', error);
      setScreenLoader(false);
      setApiMessage(RECORD_CHECK_REQUEST_ERROR_MESSAGE);
      setApiSubMessage(RECORD_CHECK_REQUEST_ERROR_MESSAGE_2);
      setIsApiSuccessOpen(true);
      setIsApiError(true);
    }
  };

  const renderSearchTableHead = () => (
    <>
      <RACTableCell>
        <RACCheckBox
          label=""
          size="small"
          name="select_all"
          checked={selectAll}
          onChange={(e) => handleSelectAll(e)}
        />
      </RACTableCell>
      {CRCGridHeader.map((col, index) => (
        <RACTableCell className="racstrap-tablecell-BgColor" key={index}>
          {col === 'First Name' || col === 'Last Name' ? (
            <a
              onClick={() => handleSort(col)}
              style={{ cursor: 'pointer', marginLeft: 8 }}
            >
              {col}
              {sortedColumn === col && sortOrder === 'asc' ? (
                <SortDownIcon className="ms-1" />
              ) : (
                <SortUpIcon className="ms-1" />
              )}
            </a>
          ) : (
            col
          )}
        </RACTableCell>
      ))}
    </>
  );

  const renderSearchTableContent = (): JSX.Element => {
    if (queuedCustomers.length === 0) {
      return (
        <RACTableRow hover backgroundColor="white">
          <RACTableCell
            colSpan={CRCGridHeader.length + 1}
            style={{ textAlign: 'center', padding: '20px', fontWeight: 'bold' }}
          >
            No Records Found
          </RACTableCell>
        </RACTableRow>
      );
    }

    return (
      <>
        {queuedCustomers.map((record, index) => (
          <RACTableRow key={index} backgroundColor="white">
            <RACTableCell>
              <RACCheckBox
                label=""
                size="small"
                name={`checkbox_${index}`}
                checked={record.checked === 1}
                onChange={(e) => handleCheckboxChange(e, index)}
              />
            </RACTableCell>
            <RACTableCell>{record?.lastName}</RACTableCell>
            <RACTableCell>{record?.firstName}</RACTableCell>
            <RACTableCell>{record?.city}</RACTableCell>
            <RACTableCell>{record?.state}</RACTableCell>
            <RACTableCell>{record?.zipcode}</RACTableCell>
            <RACTableCell>
              {maskData(record?.phoneNumber, { maskType: 'unmaskPH' })}
            </RACTableCell>
            <RACTableCell>{record?.daysPastDue}</RACTableCell>
            <RACTableCell>{record?.route}</RACTableCell>
            <RACTableCell>
            {DateTimeLocalization ?
                          <RACDateTimeLabel
                            value={formatDateString(
                              record?.dueDate || ''
                            )}
                            country={store?.countryAbb}
                            displayType={'ShortDate'}
                          />
                          : formatDateString(record?.dueDate)}</RACTableCell>
            <RACTableCell>{abbrev(record?.commitment) || '-'}</RACTableCell>
            <RACTableCell>{record?.contactsTotal}</RACTableCell>
            <RACTableCell>{record?.contactsToday}</RACTableCell>
          </RACTableRow>
        ))}
      </>
    );
  };

  return (
    <>
      {screenLoader === true ? (
        <Grid className={classes.masterLoader}>
          <Grid className={classes.Loader}>
            <CircularProgress />
          </Grid>
        </Grid>
      ) : null}
      {isApiSuccessOpen && (
        <ApiSuccessModal
          open={isApiSuccessOpen}
          message={apiMessage}
          secondmsg={apiSubMessage}
          error={isApiError}
          isNoRecordsFound={isNoRecordsFound}
          onClose={() => {
            if (!isApiError && remainingCust) {
              addToQueue(remainingCust, false);
            }
            setApiMessage('');
            setApiSubMessage('');
            setIsApiSuccessOpen(false);
            setIsApiError(false);
            setIsNoRecordsFound(false);
          }}
        />
      )}
      {queuedCustomers.length > 0 && (
        <Grid
          container
          className={`${classes.mt2px} ${classes.width100p} ${classes.displayFlex} ${classes.alignments}`}
        >
          <Typography className={`${classes.mt2px} ${classes.testclr}`}>
            {selectedCount} Selected
          </Typography>
          <RACButton
            variant="contained"
            className={`${classes.floatRight} ${classes.ms2} ${classes.mt2} ${classes.ml}`}
            color="primary"
            disabled={selectedCount === 0}
            onClick={() => handleRecordChkReqst()}
          >
            Submit Customer Record Check Request
          </RACButton>
        </Grid>
      )}

      <Grid
        container
        className={`${classes.width100p} px-2 mb-2 ${classes.mt10px} ${classes.mb20px}`}
      >
        <Card className={`${classes.width100p} card`}>
          <CardContent className={classes.width100p}>
            <InfiniteScroll
              next={fetchNextPage}
              dataLength={queuedCustomers?.length || 0}
              hasMore={false}
              height={containerHeight}
              loader={queuedCustomers?.length ? <Loader /> : null}
            >
              <Grid item md={12} className={classes.width100p}>
                <RACTable
                  renderTableHead={renderSearchTableHead}
                  renderTableContent={renderSearchTableContent}
                  stickyHeader
                />
              </Grid>
            </InfiniteScroll>
          </CardContent>
        </Card>
      </Grid>
    </>
  );
};

export default CustomerQueue;
